
    import chunk from 'chunk';

export default {
        props: [],
        components: {

        },
        data : function(){
            return {
            };
        },
        computed: {

            account()
            {
                return this.$store.getters.getAccount;

            },

            storeLive() {
                return this.$store.getters.getStoreStatus;
            },

            loading() {
                return this.$store.getters.getLoading;
            }

        },
        watch:{

            loading(newVal){



            }
        },
        created : function(){

        },
        mounted : function ()
        {


        },
        methods:{

            showDivider(thisElement, nextElement, lastElement) {
                return thisElement && nextElement ? true : thisElement && lastElement ? true : false;
            }

        }



    }
